import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Container, Row, Col, Button, Accordion, Card } from "react-bootstrap";
import * as settingActions from "../../actions/settingActions";
import * as homePageActions from "../../actions/homePageActions";
import * as forumActions from "../../actions/forumActions";
import Question from "./question";
import Answer from "./answer";
import ReportAdmin from "./reportadmin";
import { useLocation, useNavigate } from "react-router-dom";
import Moment from "moment";
import Paginate from "../../Component/Paginate";
import { imgPath } from "../../utils/imagePath";
import queryString from "query-string";
import { getDatabase, ref, set, get } from "firebase/database";
import PopupModalWithOk from "../../utils/helpers/popupModalOk";
import PropTypes from "prop-types";

const Index = (props) => {

  const { categories, forums, forumusers, actions, userInfo, isAuth, setting } = props;
  const history = useNavigate();
  const location = useLocation();
  const [room, setRoom] = useState({ roomname: "" });
  const [popupMessage, setPopupMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  let forum_heading = '';

  if (userInfo.role_id == 'Mentor') {
    forum_heading = 'Mentors';
  }
  else if (userInfo.role_id == 'Mentees') {
    forum_heading = 'Mentees';
  }

  const siteName = setting?.name?.trim() || "Forum";

  useEffect(() => {
    const title = `${siteName} - Forum`;

    document.title = title;

    actions.loadCategoryData(); // Question Category
    actions.saveForumUser(userInfo.id); // Forum user add
    actions.loadForumUserData(userInfo.role_id); // Forum user get for Forum Members

    if (room.roomname) {
      history("/chat?roomKey=" + room.roomname);
    }
  }, [siteName, actions, room, history, actions]);

  const [disbaled] = useState('join-bt-active');
  const [modalShow, setModalShow] = useState(false);
  const [userData, setUserData] = useState({});
  const [answerShow, setAnswerShow] = useState(false);
  const [reportModalShow, setReportModalShow] = useState(false);

  const askQuestionModal = (e) => {
    actions.loadCategoryData();
    e.preventDefault();
    setModalShow(true);
    setUserData({
      user_id: userInfo.id,
      categories: categories
    });
  };

  const replyAnswerModal = (e, ques_id) => {
    e.preventDefault();
    setAnswerShow(true);
    setUserData({
      user_id: userInfo.id,
      ques_id: ques_id
    });
  };

  const viewReportModal = (e, ques_id, ans_id, report_type) => {
    e.preventDefault();
    setReportModalShow(true);
    setUserData({
      user_id: userInfo.id,
      ques_id: ques_id,
      ans_id: ans_id,
      report_type: report_type
    });
  };

  const likeAnswer = (ques_id, ans_id) => {
    const ans_params = {};
    ans_params.user_id = userInfo.id;
    ans_params.ques_id = ques_id;
    ans_params.ans_id = ans_id;
    actions.saveForumAnswerLike(ans_params);
  };

  const prepareHtml = (description) => {
    return { __html: description || "" };
  };

  const handleClickChat = async (item) => {
    if (!isAuth) {
      setPopupMessage(
        "Thank you for browsing! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account."
      );
      setShowPopup(true);
      history(`/login`);
      return;
    }

    // Determine room key
    const roomUser =
      userInfo.id > item.user_id
        ? `${userInfo.id}_${item.user_id}`
        : `${item.user_id}_${userInfo.id}`;

    const db = getDatabase(); // new Firebase v9 syntax
    const time = Moment.utc().valueOf();

    const message = {
      mentor_name: item.full_name,
      mentor_image: item.image,
      mentor_id: item.user_id,
      mentee_name: userInfo?.full_name,
      mentee_image: userInfo?.image,
      mentee_id: userInfo?.id,
      device_type: "Web",
      message: "",
      key: roomUser,
      role_id: userInfo.role_id,
      status: 0,
      time: Moment(new Date()).format("DD/MM/YYYY HH:mm:ss"),
      epoch: -1 * time,
    };

    setRoom((prevRoom) => ({ ...prevRoom, roomname: roomUser }));

    // Write to mentor user node if it doesn’t exist
    const mentorDatabaseKey = `users/${item.user_id}/${roomUser}`;
    const mentorRef = ref(db, mentorDatabaseKey);
    const mentorSnap = await get(mentorRef);
    if (!mentorSnap.exists()) {
      await set(mentorRef, message);
    }

    // Write to mentee user node if it doesn’t exist
    const menteeDatabaseKey = `users/${userInfo.id}/${roomUser}`;
    const menteeRef = ref(db, menteeDatabaseKey);
    const menteeSnap = await get(menteeRef);
    if (!menteeSnap.exists()) {
      await set(menteeRef, message);
    }
  };

  const handlePageClick = (data) => {
    let page = data + 1;
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    history({
      pathname: "/forumtest",
      search: "?" + params,
    });
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    const request = {};
    if (params.get("page")) {
      let page = queryStringParsed["page"];
      request.page = page;
    }
    actions.loadForumData(userInfo.id, request); // Forum Details

  }, [actions, location]);

  return (
    <div>
      <section className="community_section">
        <div className="content_inner">
          <img
            src='http://localhost/vlookup/api/public/upload/community/1622722440.jpg'
            alt="women leadership mentoring"
            className="img-fluid back_img"
          />
          <img
            src="assets/img/cm_back_shape.png"
            className="img-fluid shape_img"
            alt="find a career mentor online"
          />
        </div>
      </section>
      <section className="community_page_inner">
        <Container className="container">
          <div className="row_c d-flex">
            <div className="community_content">
              <h2 className="community_heading">{forum_heading} Forum</h2>
            </div>
            <div className="group_c d-flex align-items-center justify-content-center ms-auto">
              <button
                onClick={(e) => {
                  askQuestionModal(
                    e
                  );
                }}
                className={"mr-3 " + disbaled}  >
                Ask a Question
              </button>
            </div>
          </div>

          <Row className="mt-4">
            <Col lg="8" md="7">
              <Paginate onClick={handlePageClick} />
              <div className="whole_content">
                <div className="forum_page_contant faqouter">
                  <Accordion defaultActiveKey={1}>

                    {/* {forums && */}
                      {forums.map((item, key) => (
                        <Card key={key + 1}>
                          <Card.Header>
                            <Accordion.Header as={Button} eventKey={key + 1} className="faq_open">Q. {item.question}</Accordion.Header>
                          </Card.Header>
                          <Accordion.Body eventKey={key + 1}>
                            <Card.Body>

                              <div className="forum_contant_body">
                                <div className="answer_top_info">
                                  <div className="answer_list_left">
                                    <div className="answer_count"><i className="far fa-comment-dots"></i>{item.answers.length} Answer(s)</div>
                                    <Button className="btn reply_btn" onClick={(e) => {
                                      replyAnswerModal(
                                        e,
                                        item.id,
                                      );
                                    }} ><i className="fas fa-reply"></i>Reply</Button>
                                    <Button className="btn reply_btn" onClick={(e) => {
                                      viewReportModal(
                                        e,
                                        item.id,
                                        '',
                                        'question'
                                      );
                                    }} title="Report to Admin"><i className="fas fa-flag"></i> Report</Button>
                                  </div>
                                  <span className="timeing">Asked {item.asked_ago}</span>
                                </div>

                                {item.answers && item.answers.length > 0 &&
                                  item.answers.map((item, key) => (
                                    <div className="answer_list" key={item.id}>
                                      <h4>Answers</h4>
                                      <div
                                        dangerouslySetInnerHTML={prepareHtml(
                                          item.answer
                                        )}
                                      ></div>
                                      <div className="answer_bottom">
                                        <div className={"answer_list_left "}>
                                          <Button className="btn reply_btn" onClick={(e) => {
                                            viewReportModal(
                                              e,
                                              item.id,
                                              item.id,
                                              'answer'
                                            );
                                          }} title="Report to Admin"><i className="fas fa-flag"></i> Report</Button>
                                          <Button className="likes_count" style={{}} onClick={(e) => {
                                            likeAnswer(
                                              item.id,
                                              item.id,
                                            );
                                          }} ><i className="fas fa-thumbs-up"></i>{item.likes} Likes</Button>
                                          <div className="posted_by"><span>Posted By</span>{item.posted_by}</div>
                                        </div>
                                        <span className="timeing">Posted On {item.posted_ago}</span>
                                      </div>
                                    </div>
                                  ))}

                              </div>

                            </Card.Body>
                          </Accordion.Body>
                        </Card>
                      ))}
                  </Accordion>
                </div>
              </div>
            </Col>

            <Col lg="4" md="5" className="mt-4 mt-md-0">
              <div className="sidebar_community overflow_custom_style">
                <div className="d-flex align-items-center heading justify-content-between mb-4">
                  <h2>Forum Members ({forumusers.length}) </h2>
                </div>

                {/* LIST */}
                {/* {forumusers && */}
                  {forumusers.map((item) => (
                    <div className="member_list" key={item.id}>
                      <ul>
                        <li className="d-flex align-items-center mb-3">
                          <div className="member_image">
                            {item.image && (
                              <img
                                src={item.image}
                                alt="career coaching for women"
                                className="img-fluid"
                              />
                            )}
                            {!item.image && (
                              <img
                                src={
                                  imgPath +
                                  "mentor_women_two.png"
                                }
                                className="img-fluid"
                                alt="career mentor consulting"
                              />
                            )}
                          </div>
                          <div className="member_detail ms-3">
                            <h3>{item.full_name}</h3>
                            <h4>{item.position}</h4>
                            <h4>{item.organization}</h4>
                            {userInfo.id != item.user_id && (
                              <button
                                className="link_btn btn btn_red"
                                onClick={() => handleClickChat(item)}
                              >
                                <img
                                  src={
                                    imgPath + "msg.png"
                                  }
                                  alt="msg_icon"
                                  className="me-2 bg-white"
                                />{""}
                                Send Message
                              </button>)}
                          </div>
                        </li>
                      </ul>
                    </div>
                  ))}
                  {forumusers.length === 0 && (
                    <div className="text-center">No Joined User found.</div>
                  )}
                {/* LIST */}
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {modalShow && (
        <Question
          show={modalShow}
          userdata={userData}
          onHide={() => setModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}

      {answerShow && (
        <Answer
          show={answerShow}
          userdata={userData}
          onHide={() => setAnswerShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}

      {reportModalShow && (
        <ReportAdmin
          show={reportModalShow}
          userdata={userData}
          onHide={() => setReportModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}

      <PopupModalWithOk
        show={showPopup}
        onHide={() => {
          setShowPopup(false); // close popup
        }}
        message={popupMessage}
        showConfirm={false}
        staticBackdrop={true}
      />

    </div>
  );
};

Index.propTypes = {
  setting: PropTypes.object.isRequired,
  isAuth: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    role_id: PropTypes.string,
    full_name: PropTypes.string,
    image: PropTypes.string,
  }).isRequired,
  categories: PropTypes.array.isRequired,
  forums: PropTypes.shape({
    data: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    map: PropTypes.func,
  }).isRequired,
  forumusers: PropTypes.shape({
    length: PropTypes.number,
    map: PropTypes.func,
  }).isRequired,
  actions: PropTypes.shape({
    loadCategoryData: PropTypes.func.isRequired,
    saveForumUser: PropTypes.func.isRequired,
    loadForumUserData: PropTypes.func.isRequired,
    loadForumData: PropTypes.func.isRequired,
    saveForumAnswerLike: PropTypes.func.isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    setting: state.setting,
    brand: state.brand,
    isAuth: state.isAuth,
    userInfo: state.userInfo,
    categories: state.categories,
    forums: state.forums,
    forumusers: state.forumusers,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {...settingActions, ...homePageActions, ...forumActions},
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
